import instanceSettingsApi from './instanceSettingsApi';

const deleteInstanceSetting = async (app: string, key: string) => {
  try {
    const { data } = await instanceSettingsApi.delete(
      `/${encodeURIComponent(app)}/${encodeURIComponent(key)}`,
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    );
    return data;
  } catch (error) {
    console.error('[deleteInstanceSetting] Failed:', error);
    throw error;
  }
};

export default deleteInstanceSetting;
